import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';
import {StyleAttributeImm} from '@packages/systems/wfdl';
import {Map} from 'immutable';
import {
  type EvaluatedNodeData,
  getArray,
  getBoolean,
  getRecord,
  getString,
} from '@packages/utilities/data-utils';

type EventIdAttributeMap = Map<
  string,
  string | StyleAttributeImm | Map<string, string>
>;

const addEventIdsAttribute =
  (
    runtimeEnvironment: Environment,
    hasEventIds: boolean,
    eventIdNames: Array<string>
  ) =>
  (attributes: EventIdAttributeMap) => {
    if (runtimeEnvironment === WebflowEnvironments.SSR && hasEventIds) {
      return attributes.set('data-wf-event-ids', eventIdNames.join('-'));
    }

    return attributes;
  };

export const maybeAddEventIdsFromData = (
  runtimeEnvironment: Environment,
  data: EvaluatedNodeData
) => {
  const eventIds = getArray(getRecord(data)?.eventIds);
  const eventIdNames = eventIds
    ? eventIds.reduce((acc: Array<string>, curr) => {
        const eventId = getRecord(curr);
        if (getBoolean(eventId?.value)) {
          const name = getString(eventId?.name);
          if (name) {
            acc.push(name);
          }
        }

        return acc;
      }, [])
    : [];

  return addEventIdsAttribute(
    runtimeEnvironment,
    Boolean(eventIds && eventIds.length > 0),
    eventIdNames
  );
};
